import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { Package } from "lucide-react";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function googleLogin() {
  const redirectUrl = window.location.origin + "/dashboard";
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
}

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Willkommen zurück!");
      nav(u.role === "admin" ? "/admin" : u.role === "transport_partner" ? "/partner" : "/dashboard");
    } catch (e) {
      setErr(apiError(e.response?.data?.detail) || e.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="eb-container max-w-md py-16">
      <div className="eb-card p-8 eb-fade-up">
        <div className="w-11 h-11 rounded-xl bg-[#FF5A1F] flex items-center justify-center mb-5">
          <Package className="w-6 h-6 text-white" />
        </div>
        <h1 className="font-head text-2xl font-bold mb-1">Anmelden</h1>
        <p className="text-sm text-slate-400 mb-6">Willkommen bei Easy Beiladung.</p>
        <button onClick={googleLogin} data-testid="google-login-btn"
          className="eb-btn-outline w-full mb-4">
          <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg" className="w-4 h-4" alt="" /> Mit Google anmelden
        </button>
        <div className="flex items-center gap-3 my-4 text-xs text-slate-500">
          <div className="flex-1 h-px bg-slate-800" /> oder <div className="flex-1 h-px bg-slate-800" />
        </div>
        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="eb-label">E-Mail</label>
            <input className="eb-input mt-1.5" type="email" value={email} required
              onChange={(e) => setEmail(e.target.value)} data-testid="login-email-input" />
          </div>
          <div>
            <label className="eb-label">Passwort</label>
            <input className="eb-input mt-1.5" type="password" value={password} required
              onChange={(e) => setPassword(e.target.value)} data-testid="login-password-input" />
          </div>
          {err && <div className="text-sm text-red-400" data-testid="login-error">{err}</div>}
          <button className="eb-btn-primary w-full" disabled={loading} data-testid="login-submit-btn">
            {loading ? "Anmelden…" : "Anmelden"}
          </button>
        </form>
        <p className="text-sm text-slate-400 mt-5 text-center">
          Noch kein Konto? <Link to="/registrieren" className="text-[#FF5A1F] hover:underline">Registrieren</Link>
        </p>
      </div>
    </div>
  );
}
